import { render, staticRenderFns } from "./TaxOffice.vue?vue&type=template&id=da2e596a&"
import script from "./TaxOffice.vue?vue&type=script&lang=js&"
export * from "./TaxOffice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports